import { render, staticRenderFns } from "./advRegisterOnPublic.vue?vue&type=template&id=856fde46&scoped=true&"
import script from "./advRegisterOnPublic.vue?vue&type=script&lang=js&"
export * from "./advRegisterOnPublic.vue?vue&type=script&lang=js&"
import style0 from "./advRegisterOnPublic.vue?vue&type=style&index=0&id=856fde46&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "856fde46",
  null
  
)

export default component.exports